// VFX: Karaoke Color Sweep
// Slug: text_karaoke_color-sweep_loop
// Category: text-emphasis
import { AbsoluteFill, useCurrentFrame } from "remotion";
import React from "react";

type Props = { sentence?: string; highlightColor?: string; framesPerWord?: number };

export default function TextKaraokeColorSweepLoop({
  sentence = "Build something people love every single day",
  highlightColor = "#60a5fa",
  framesPerWord = 16,
}: Props) {
  const frame = useCurrentFrame();
  const words = sentence.split(" ");
  const activeIndex = Math.floor(frame / framesPerWord) % words.length;
  return (
    <AbsoluteFill style={{ alignItems: "center", justifyContent: "center", padding: "0 60px", background: "#050508" }}>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "0 14px", justifyContent: "center" }}>
        {words.map((word, i) => {
          const isActive = i === activeIndex;
          const isPast = i < activeIndex;
          return (
            <span
              key={i}
              style={{
                fontSize: 56,
                fontWeight: 800,
                fontFamily: "sans-serif",
                color: isPast ? highlightColor : isActive ? "#fff" : "rgba(255,255,255,0.35)",
                textShadow: isActive ? `0 0 24px ${highlightColor}aa` : "none",
              }}
            >
              {word}
            </span>
          );
        })}
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
